import { DecorationModel } from "../_model/DecorationModel";
import { ControllerProductionChange } from "../productionChange/controllerProductionChange"
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors"
import * as d3 from "d3"

export class DecorationProductionChange extends DecorationModel {
  constructor() {
    super("DecorationProductionChange")
    this.moving = false;
    this.node = null;
    this.ctr = new ControllerProductionChange();
  
    this.init = async function (newNode, openDialog) {
      let svg = SingletonFlowchart.svg
      this.node = newNode
      this.openDialog = openDialog
  
      await svg
        .data([newNode])
        .append("g")
          .attr("id", `${newNode.idName}`)
          //.on("dblclick", () => openDialog(newNode))

          // Caixa de Descrição
          .append("rect")
          .classed("productionChange", true)
          .attr("x",  d => d.x)
          .attr("y", d => d.y)
          .style("width", newNode.width)
          .style("height", newNode.height)
          .style("cursor", "grab")
          .style("fill", COLORS.OrangePentagro3).node();
            
      let g = d3.select(`#${newNode.idName}`);

      // Caixa de Açúcar
      g.append("rect")
        .classed("sugar", true)
        .attr("x",  d => d.xBoxSugar())
        .attr("y", d => d.yBoxSugar())
        .style("width", newNode.widthOption)
        .style("height", newNode.height)
        .style("cursor", "pointer")
        .style("fill", d => (d.optionSelect() == "1,00" ? COLORS.OrangePentagro1 : COLORS.OrangePentagro3))
        .on("click", () => this.alterSelect(newNode, "1,00"))

      // Caixa de Ethanol
      g.append("rect")
        .classed("ethanol", true)
        .attr("x",  d => d.xBoxEthanol())
        .attr("y", d => d.yBoxEthanol())
        .style("width", newNode.widthOption)
        .style("height", newNode.height)
        .style("cursor", "pointer")
        .style("fill", d => (d.optionSelect() == "2,00" ? COLORS.OrangePentagro1 : COLORS.OrangePentagro3))
        .on("click", () => this.alterSelect(newNode, "2,00"))

      // Texto de Descrição
      g.append("text")
        .classed("description", true)
        .text("Setar vazão caldo para")
        .attr("x",  d => d.xTextDescription())
        .attr("y", d => d.yTextDescription())
        .attr("font-size", d => d.fontSize)
        .style("font-weight", 400)
        .style("color", COLORS.Black95)

      // Texto de Açúcar
      g.append("text")
        .text("Fábrica")
        .classed("sugar", true)
        .style("cursor", "pointer")
        .attr("x",  d => d.xTextSugar())
        .attr("y", d => d.yTextSugar())
        .attr("font-size", d => d.fontSize)
        .style("font-weight", 700)
        .style("color", COLORS.Black95)
        .on("click", () => this.alterSelect(newNode, "1,00"))

      // Texto de Açúcar
      g.append("text")
        .text("Destilaria")
        .classed("ethanol", true)
        .style("cursor", "pointer")
        .attr("x",  d => d.xTextEthanol())
        .attr("y", d => d.yTextEthanol())
        .attr("font-size", d => d.fontSize)
        .style("font-weight", 700)
        .style("color", COLORS.Black95)
        .on("click", () => this.alterSelect(newNode, "2,00"))
      
      g.call(this.setDrag())

      this.alterSelect(newNode, newNode.optionSelect())

      
      return svg
    }
  
    this.setDrag = function() {
      if(this.node.readOnly)
        return d3.drag();

      let that = this
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d, that))
        .on("end", (event, d) => that.dragended(d, that));
      return drag;
    }

    this.dragstarted = function(event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`)
    }

    this.dragged = async function (event, d, that){
      d.x = event.x;
      d.y = event.y;
      
      if (!that.moving){
        that.moving = true;

        d3.select(`#${d.idName}`)
          .style("cursor", "grabbing")
          .style("stroke", "black")
      }

      that.move();
    } 

    this.move = async () => {
      let d = this.node

      d3.select(`#${d.idName} > rect.productionChange`)
        .raise()
        .attr("x", d.x)
        .attr("y", d.y)

      d3.select(`#${d.idName} > rect.sugar`)
        .raise()
        .attr("x", d.xBoxSugar())
        .attr("y", d.yBoxSugar())

      d3.select(`#${d.idName} > rect.ethanol`)
        .raise()
        .attr("x", d.xBoxEthanol())
        .attr("y", d.yBoxEthanol())

      d3.select(`#${d.idName} > text.description`)
        .raise()
        .attr("x", d.xTextDescription())
        .attr("y", d.yTextDescription())
      
      d3.select(`#${d.idName} > text.sugar`)
        .raise()
        .attr("x", d.xTextSugar())
        .attr("y", d.yTextSugar())

      d3.select(`#${d.idName} > text.ethanol`)
        .raise()
        .attr("x", d.xTextEthanol())
        .attr("y", d.yTextEthanol())
    }

    this.dragended = function(d, that) {
      d3.select(`#${d.idName}`)
        .style("stroke", 'none')
        .style("cursor", "grab")

      that.moving = false;
    };

    this.alterSelect = async function (d, op){
      let sugar = d3.select(`#${d.idName} > rect.sugar`)
      let ethanol = d3.select(`#${d.idName} > rect.ethanol`)
      d.optionSelect(op);
      // let backupNodes = []

      if(op == "1,00"){
        sugar.style("fill", COLORS.OrangePentagro1)
        ethanol.style("fill", COLORS.OrangePentagro3)

        // d.nodesToFab.forEach(n => this.showThisNode(n))

        // await d.nodesToDest.forEach(async n => {
        //   let nodeToBackup = await this.disappearThisNode(n)
        //   if(nodeToBackup) backupNodes.push(nodeToBackup)
        // })
        // d.nodesToDest = backupNodes;
      }
      else
      {
        sugar.style("fill", COLORS.OrangePentagro3)
        ethanol.style("fill", COLORS.OrangePentagro1)

        // d.nodesToDest.forEach(n => this.showThisNode(n))

        // d.nodesToFab.forEach(n => {
        //   let nodeToBackup = this.disappearThisNode(n)
        //   if(nodeToBackup) backupNodes.push(nodeToBackup)
        // })
        // d.nodesToFab = backupNodes;
      }
    }

    this.disappearThisNode = function (n){
      let node = SingletonFlowchart.Memory.memory.find(n2 => {
        if(n2.data){
          let attr = n2.data.find(attr => {
            if(attr.index == n.data[0].index && attr.key == n.data[0].key)
              return true
            return false
          })
          if(attr)
            return true
        }
          
        return false
      })
      if(node) {
        node.kill()
        return node
      }
    }

    this.showThisNode = function (n){
      let hasNode = document.querySelector(`#${n.idName}`)
      if(!hasNode)
        n.decorate(this.openDialog)
    }

    this.reloadProperties = () => {
      this.alterSelect(this.node, this.node.data[0].value)
      this.isInvisible()
    }
  }
}